// modules
import { combineReducers } from 'redux'

import billing from 'src/store/modules/actions/billing'
import medicalDeviceManagement from 'src/store/modules/actions/medicalDeviceManagement'
import medicalDeviceOrdering from 'src/store/modules/actions/medicalDeviceOrdering'
import telehealth from 'src/store/modules/actions/telehealth'
import urgentCare from 'src/store/modules/actions/urgentCare'

export default combineReducers({
  billing,
  medicalDeviceManagement,
  medicalDeviceOrdering,
  telehealth,
  urgentCare
})

export * from 'src/store/modules/actions/billing'
export * from 'src/store/modules/actions/medicalDeviceManagement'
export * from 'src/store/modules/actions/medicalDeviceOrdering'
export * from 'src/store/modules/actions/telehealth'
export * from 'src/store/modules/actions/urgentCare'
